import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        bankingDetails: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
        
    },
  
    mutations: {
        setBankingDetails(state, data) {
            state.bankingDetails = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.bankingDetails = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        },
        clearSaveError(state) {
            state.saveError = "";
        }
    },
  
    actions: {
        clearSaveError(context) {
            context.commit("clearSaveError");
        },
        saveBankingDetails(context, options) {
            context.commit("saving");

            api.saveBankingDetails(
                options.bankingDetails,
                {
                    success: function(response) {
                        // the response we get back from this function is the list of items (which will include the changes we requested)
                        context.commit("setBankingDetails", response.data);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadBankingDetails(context) {
            context.commit("loading");

            api.fetchBankingDetails({
                success: function(response) {
                    context.commit("setBankingDetails", response.data);
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadComplete");
                }
            });
        }
    }
}
